import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { PaymentMethodSubscription } from '../../../../interfaces/merchants/resources/books';
import BooksCheckInput, {
  InputType,
} from '../../../books/model1/forms/BooksCheckInput';
import BookingPurchaseProduct from './common/BookingPurchaseProduct';
import css from './InputPaymentMySubscription.module.scss';

interface Props {
  merchantId: string;
  paymentMethod: PaymentMethodSubscription;
  onSelect: (purchasedSelection: string) => void;
  onClose: () => void;
  mySelection?: string;
}

class InputPaymentMySubscription extends React.Component<
  Props & InjectedIntlProps
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  public componentDidMount() {
    const {
      onSelect,
      paymentMethod: { purchased_products },
    } = this.props;
    if (purchased_products.length !== 0) {
      onSelect(purchased_products[0].public_id.toString());
    }
  }

  public componentDidUpdate(prevProps: Props) {
    const {
      onSelect,
      paymentMethod: { purchased_products },
    } = this.props;
    if (
      purchased_products !== prevProps.paymentMethod.purchased_products &&
      purchased_products.length !== 0
    ) {
      onSelect(purchased_products[0].public_id.toString());
    }
  }

  private handleSelect(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { value },
    } = e;
    this.props.onSelect(value);
  }

  public render() {
    const {
      merchantId,
      intl,
      paymentMethod: { purchased_products, products },
      mySelection,
      onClose,
    } = this.props;
    const isDisplayRetailer = purchased_products.length === 0;
    return (
      <li className={css.InputPaymentMySubscription}>
        {purchased_products.map(p => (
          <BooksCheckInput
            key={p.public_id}
            className={css.InputPaymentMySubscription__Item}
            type={InputType.Radio}
            value={p.public_id}
            checked={mySelection === p.public_id.toString()}
            onChange={this.handleSelect}
            name="payment-subscription"
            disabled={!p.available}
          >
            {p.available && p.booking_limit.limited && (
              <span>
                <span>{p.name}</span>
                <span
                  className={
                    css.InputPaymentMySubscription__PurchaseProductLimit
                  }
                >
                  {intl.formatMessage(
                    {
                      id: 'books.paymentMethod.booking_limit',
                    },
                    {
                      remain: p.booking_limit.per_month.remain,
                      total: p.booking_limit.per_month.total,
                    },
                  )}
                </span>
              </span>
            )}
            {p.available && !p.booking_limit.limited && <span>{p.name}</span>}
            {!p.available && (
              <span className={css.InputPaymentMySubscription__Disabled}>
                {`${p.name} (${intl.formatMessage({
                  id: 'books.paymentMethod.setting_limit_exceeded',
                })})`}
              </span>
            )}
          </BooksCheckInput>
        ))}
        {isDisplayRetailer && (
          <div className={css.InputPaymentMySubscription__Available}>
            {intl.formatMessage({
              id: 'books.forms.youGetSubscriptionAndTicket',
            })}
            {products.map(product => (
              <BookingPurchaseProduct
                key={product.public_id}
                merchantId={merchantId}
                product={product}
                onClose={onClose}
              />
            ))}
          </div>
        )}
      </li>
    );
  }
}

export default injectIntl(InputPaymentMySubscription);
